import { render, staticRenderFns } from "./create-patient.vue?vue&type=template&id=0d6729b4&scoped=true"
import script from "./create-patient.vue?vue&type=script&lang=js"
export * from "./create-patient.vue?vue&type=script&lang=js"
import style0 from "./create-patient.vue?vue&type=style&index=0&id=0d6729b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6729b4",
  null
  
)

export default component.exports